import { render, staticRenderFns } from "./StarRatingsEditModal.vue?vue&type=template&id=780c67e0&scoped=true"
import script from "./StarRatingsEditModal.vue?vue&type=script&lang=ts"
export * from "./StarRatingsEditModal.vue?vue&type=script&lang=ts"
import style0 from "./StarRatingsEditModal.vue?vue&type=style&index=0&id=780c67e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780c67e0",
  null
  
)

export default component.exports